import Swiper from 'swiper';

class TwoColumnHeroSlider {
  private heroSliders: NodeListOf<HTMLElement>;
  private heroes: NodeListOf<HTMLElement>;

  cache() {
    this.heroSliders = document.querySelectorAll('.js-two-column-hero-slider');
    this.heroes = document.querySelectorAll('.js-o-two-column-hero-item');
  }

  bindings() {
    this.contentToggle();
    this.heroSliders.forEach((slider, index) => {
      const TIME = 5000;
      const SPEED = 800;

      const pagination = slider.nextElementSibling as HTMLElement | null | undefined;

      new Swiper(slider, {
        effect: 'slide',
        autoHeight: true,
        speed: SPEED,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: TIME,
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
        on: {
          afterInit: () => {
            pagination?.style.setProperty('--time', `${(TIME + (SPEED / 2)) / 1000}s`);
          },
        },
        observer: true,
        observeParents: true,
      });
    });
  }

  private contentToggle() {
    this.heroes.forEach((hero) => {
      const showMoreButton: HTMLElement | null = hero.querySelector('.js-two-column-hero__button');
      const showLessButton: HTMLElement | null = hero.querySelector('.js-two-column-hero__button-close');
      const contentToShow: HTMLElement | null = hero.querySelector('.js-two-column-hero__content-wrapper');
      const parentElement: HTMLElement | null = hero.querySelector('.js-two-column-hero');

      if(contentToShow) {
        contentToShow.style.maxHeight = '0';
      }

      if (showMoreButton) {
        showMoreButton.addEventListener('click', () => {
          if (contentToShow) {
            contentToShow.classList.remove('hidden');
            contentToShow.style.maxHeight = `${contentToShow.scrollHeight}px`;
          }

          showMoreButton.classList.add('hidden');

          if (parentElement) {
            parentElement.classList.add('active');
            parentElement.closest('.o-two-column-hero')?.classList.add('active');
          }

          window.scrollTo(0, window.scrollY + 300);
        });
      }

      if (showLessButton) {
        showLessButton.addEventListener('click', () => {
          if (contentToShow) {
            contentToShow.classList.add('hidden');
            contentToShow.style.maxHeight = '0';
          }

          if (parentElement) {
            parentElement.classList.remove('active');
            parentElement.closest('.o-two-column-hero')?.classList.remove('active');
          }

          if (showMoreButton) {
            showMoreButton.classList.remove('hidden');
          }

          window.scrollTo(0, (parentElement?.getBoundingClientRect().top || 0) + window.scrollY);
        });
      }
    });
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default TwoColumnHeroSlider;
